import { DeleteShowcaseMeta, DeleteShowcasePayload } from 'types/store/DeleteShowcaseState';
import { createAsyncReducer } from 'utils/Redux';

import { deleteShowcaseActions } from '../actions';

export default createAsyncReducer<DeleteShowcaseMeta, DeleteShowcasePayload>(
    deleteShowcaseActions
);
